import React from "react";

import { constants } from "./utility.ts";
import Start from "./components/start.tsx";

const Home = () => {
  return (
    <div className="home">
      <header className= "App-header">
        <div className="flamesHeader">{constants.FLAMES}</div>
        <Start />
      </header>
    </div>
  );
};

export default Home;
